import { Injectable } from '@angular/core';
import { PlatformService } from "services/platform.service";
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class CaptchaService {

	private loadedKeys: { [key: string]: boolean } = {}
	private readyKeys: { [key: string]: boolean } = {}
	private callbacks: { [key: string]: Function[] } = {}

	private getLoader(siteKey: string) {
		return () => {
			this.readyKeys[siteKey] = true
			if (this.callbacks[siteKey]) {
				for (let callback of this.callbacks[siteKey]) {
					callback(siteKey)
				}
				this.callbacks[siteKey] = []
			}
		}
	}

	on_ready(callback: Function, customSiteKey?: string) {
		const siteKey = customSiteKey || environment.recaptcha_site_key

		if (this.readyKeys[siteKey]) {
			callback(siteKey)
		} else {
			if (!this.callbacks[siteKey]) {
				this.callbacks[siteKey] = []
			}
			this.callbacks[siteKey].push(callback)
		}

		if (!this.loadedKeys[siteKey]) {
			this.loadedKeys[siteKey] = true
			const callbackName = 'captcha_ready_' + siteKey.substring(0, 8);
			(window as any)[callbackName] = this.getLoader(siteKey)
			let script = document.createElement('script')
			script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(siteKey) + '&onload=' + callbackName
			document.head.appendChild(script)
		}
	}

	constructor(private platform: PlatformService) { }
}
